import { CallTransferFormValues } from '../../store/call-transfer/CallTransferModel';

export const getCancelTransferInitialValues = (callTransferField: CallTransferFormValues[]) => ({
  callTransferField,
});

export type CancelTransferFormBody = ReturnType<typeof getCancelTransferInitialValues>;
